import React from "react";
import { useExpertMessageContext } from "@limitless/expert";
export const useExpertAIReviewManagerHook = () => {
  const [aiReviewData, setAiReviewData] = React.useState(null);
  const [isAIDraftSelected, setIsAIDraftSelected] = React.useState(false);
  const [hasShownAnimatedIcon, setHasShownAnimatedIcon] = React.useState(false);
  const {
    fetchAIReview,
    message
  } = useExpertMessageContext();
  React.useEffect(() => {
    setAiReviewData(null);
  }, [message.messageId]);
  const fetchAndSetAIReviewData = (messageId, aiRespond, isAiRespondCreatedAt) => {
    if (isAiRespondCreatedAt) {
      setAiReviewData(aiRespond);
    } else {
      fetchAIReview(messageId, data => {
        if (data) {
          setAiReviewData(data);
        }
      });
    }
  };
  const handleAIDraftSelected = isSelected => {
    setIsAIDraftSelected(isSelected);
  };
  return {
    aiReviewData,
    isAIDraftSelected,
    fetchAndSetAIReviewData,
    handleAIDraftSelected,
    setHasShownAnimatedIcon,
    hasShownAnimatedIcon
  };
};